import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import '../styles/feed.css';
import ProfilePicture from '../components/ProfilePicture';

const Feed = () => {
    const [feedItems, setFeedItems] = useState([]);
    const userId = window.localStorage.getItem('userID');
    const cookies = new Cookies();
    const token = cookies.get('access_token');

    useEffect(() => {
        fetchFeedAndSuggestions();
    }, []);

    const fetchFeedAndSuggestions = async () => {
        try {
            console.log('Fetching feed and suggestions for user:', userId); // Debug log

            const [recipesResponse, suggestedUsersResponse] = await Promise.all([
                axios.get(`${API_BASE_URL}/recipes/feed/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                }),
                axios.get(`${API_BASE_URL}/users/suggestions/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);

            console.log('Recipes response:', recipesResponse.data); // Debug log
            console.log('Suggested users response:', suggestedUsersResponse.data); // Debug log

            const recipes = recipesResponse.data || [];
            const suggestedUsers = suggestedUsersResponse.data || [];

            // Combine and sort feed items
            const combinedFeed = [
                ...recipes.map(recipe => ({ ...recipe, type: 'recipe' })),
                ...suggestedUsers.map((user, index) => ({
                    ...user,
                    type: 'suggestion',
                    position: (index + 1) * 3 // Show suggestion after every 3 recipes
                }))
            ].sort((a, b) => {
                if (a.type === 'suggestion') {
                    return a.position - (b.type === 'suggestion' ? b.position : recipes.length);
                }
                return new Date(b.createdAt) - new Date(a.createdAt);
            });

            console.log('Combined feed:', combinedFeed); // Debug log
            setFeedItems(combinedFeed);
        } catch (error) {
            console.error('Error fetching feed:', error);
            setFeedItems([]);
        }
    };

    const handleFollow = async (userToFollowId) => {
        try {
            await axios.post(
                `${API_BASE_URL}/users/follow/${userToFollowId}`,
                { userId },
                { headers: { Authorization: `Bearer ${token}` }}
            );
            // Refresh feed after following
            fetchFeedAndSuggestions();
        } catch (error) {
            console.error('Error following user:', error);
        }
    };

    const renderFeedItem = (item) => {
        if (item.type === 'recipe') {
            return (
                <div key={item._id} className="feed-item recipe-post">
                    <div className="post-header">
                        <Link to={`/profile/${item.userOwner?._id}`} className="user-info">
                            <ProfilePicture 
                                src={item.userOwner?.profilePicture}
                                alt={item.userOwner?.username}
                                className="user-avatar"
                            />
                            <span className="username">{item.userOwner?.username || 'Unknown User'}</span>
                        </Link>
                    </div>
                    <div className="post-image">
                        <img 
                            src={item.imageUrl} 
                            alt={item.name}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/default-recipe.png';
                            }}
                        />
                    </div>
                    <div className="post-content">
                        <h3>{item.name}</h3>
                        <p className="cooking-time">Cooking Time: {item.cookingTime} minutes</p>
                        <Link to={`/recipe/${item._id}`} className="view-recipe">
                            View Recipe
                        </Link>
                    </div>
                </div>
            );
        } else if (item.type === 'suggestion') {
            return (
                <div key={`suggestion-${item._id}`} className="feed-item suggestion-card">
                    <div className="suggestion-header">
                        <h4>Suggested User</h4>
                    </div>
                    <div className="suggestion-content">
                        <Link to={`/profile/${item._id}`} className="user-info">
                            <ProfilePicture 
                                src={item.profilePicture}
                                alt={item.username}
                                className="user-avatar"
                            />
                            <span className="username">{item.username}</span>
                        </Link>
                        <button 
                            onClick={() => handleFollow(item._id)}
                            className="follow-button"
                        >
                            Follow
                        </button>
                    </div>
                </div>
            );
        }
    };

    return (
        <div className="feed-container">
            <div className="feed-column">
                {feedItems.length === 0 ? (
                    <div className="empty-feed">
                        <p>No recipes yet. Follow some users to see their recipes!</p>
                    </div>
                ) : (
                    feedItems.map(item => renderFeedItem(item))
                )}
            </div>
        </div>
    );
};

export default Feed; 